// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GooglePlusOutlinedSvg from "@fishx/icons-svg/es/asn/GooglePlusOutlined";
import FishxIcon from '../components/FishxIcon';

var GooglePlusOutlined = function GooglePlusOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GooglePlusOutlinedSvg
  }));
};

GooglePlusOutlined.displayName = 'GooglePlusOutlined';
export default React.forwardRef(GooglePlusOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GooglePlusOutlined.js
// module id = 2893
// module chunks = 0